export default class imageLeftContentRight {

    constructor() {
        this.container = document.querySelectorAll('.image-with-content');

        // Is the element present on the current page
        if (!this.container) {
            return;
        }

       this.moveheading();
        /** Trigger on browser resize */
       window.addEventListener('resize', () => {
            this.moveheading();
        });
        /** Trigger on mobile orientation change */
        window.addEventListener("orientationchange", () => {
            this.moveheading();
        });
    }

    moveheading() {
        const image_with_content = this.container;
        // Define the media query
        const mediaQuery = window.matchMedia('(max-width: 991px)');
        var i;
        for (i = 0; i < image_with_content.length; i++) {
            this.heading = image_with_content[i].querySelector('.heading-move');
            this.content = image_with_content[i].querySelector('.image-with-content__content');
            if (this.heading) {
                if (mediaQuery.matches) {
                    image_with_content[i].prepend(this.heading);
                } else {
                    this.content.prepend(this.heading);
                }
            }
        }
    }
}
